import React from 'react';
import '../styles/legal.css';

export const TermsPage = () => (
  <div className="legal-page">
    <div className="legal-inner">
      <a href="/" className="legal-back">← Back to Stimuli Central</a>
      <h1 className="legal-title">Terms of Service</h1>
      <p className="legal-updated">Last updated: June 2026</p>

      <section className="legal-section">
        <h2>Use of the service</h2>
        <p>Stimuli Central is a tool to assist ABA therapists and educators with stimulus training. You are responsible for using it in accordance with applicable laws and professional ethical guidelines in your jurisdiction.</p>
      </section>

      <section className="legal-section">
        <h2>Accounts</h2>
        <p>You must provide accurate information when creating an account. You are responsible for maintaining the security of your account credentials. Stimuli Central is not liable for unauthorized access resulting from failure to protect your credentials.</p>
      </section>

      <section className="legal-section">
        <h2>Trial accounts</h2>
        <p>Free trial accounts provide 2 weeks of full access. After the trial period, access is restricted until you upgrade to a paid plan.</p>
      </section>

      <section className="legal-section">
        <h2>User content</h2>
        <p>You retain ownership of any photos or content you upload. By uploading content, you grant Stimuli Central a limited license to store and display it within the app for your use. You must not upload content that is illegal, harmful, or that you do not have rights to use.</p>
      </section>

      <section className="legal-section">
        <h2>Disclaimers</h2>
        <p>Stimuli Central is a software tool and is not a substitute for professional clinical judgment. Results and session data are provided for informational purposes only. We make no guarantees about clinical outcomes.</p>
      </section>

      <section className="legal-section">
        <h2>Limitation of liability</h2>
        <p>To the maximum extent permitted by law, Stimuli Central is not liable for any indirect, incidental, or consequential damages arising from your use of the service.</p>
      </section>

      <section className="legal-section">
        <h2>Contact</h2>
        <p>Questions? Email us at <a href="mailto:hello@stimulicentral.org">hello@stimulicentral.org</a>.</p>
      </section>
    </div>
  </div>
);
